var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"tree__sub"},[_c('a',{staticClass:"tree__sub-link tree__sub-link--disabled"},[_vm._v("\n    "+_vm._s(_vm.jobSidebarText)+"\n    "),_c('div',{staticClass:"tree__progress-percentage"},[_vm._v("\n      "+_vm._s(_vm.job.progress_percentage)+" %\n    ")])]),_vm._v(" "),_c('div',{staticClass:"tree__sub-link--loading"})])
}
var staticRenderFns = []

export { render, staticRenderFns }